

export const tabsList = [
  {
    id: 1,
    label: 'My messages',
    intlKey: 'tabs.my_messages',
    path: '/my-messages',
    type: 'tab',
    authorized: true
  },
  {
    id: 2,
    label: 'All messages',
    intlKey: 'tabs.all_messages',
    path: '/all-messages',
    type: 'tab',
    authorized: true
  }
]

export const tableHeaders = () => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Group ID',
    intlKey: 'table.group_id',
    sortableId: 'groupId'
  },
  {
    id: 3,
    label: 'Message type',
    intlKey: 'table.message_type'
  },
  {
    id: 4,
    label: 'Message channel',
    intlKey: 'table.recipient_message_channel'
  },
  {
    id: 5,
    label: 'Created at',
    intlKey: 'table.message_created_at',
    sortableId: 'createdAt'
  },
/*  {
    id: 6,
    label: 'Read at',
    intlKey: 'table.message_read_at',
    sortableId: 'readDate'
  },*/
  {
    id: 6,
    label: 'Sent by',
    intlKey: 'table.message_sent_by'
  },
  {
    id: 7,
    label: 'Subject',
    intlKey: 'table.message_subject'
  },
  {
    id: 8,
    label: 'Message',
    intlKey: 'table.message_content'
  },
  {
    id: 9,
    label: 'Recipients',
    intlKey: 'table.message_recipients'
  }
]
